// Module
var code = `<!-- ko if: item.visible -->
<!-- ko component: { name: item.componentName, params: { model: item.componentData } } -->
<!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;